module.exports = __webpack_public_path__ + "img/gonetwork2_icon18.764a2dba.png";